import faqSchema from '../schemas/faq';
import breadcrumbSchema from '../schemas/breadcrumb';
import itemlistSchema from '../schemas/itemlist';
// import reviewsSchema from '../schemas/reviews';
import organization from '../schemas/organisation.json';

const goalSchema = (faqs, goalName, goalURL, items, description) => {
  const breads = [
    {
      name: 'Explore',
      url: 'https://unacademy.com/explore'
    },
    {
      name: goalName,
      url: goalURL
    }
  ];
  const courses =
    items.filter((item) => item.type === 'special_classes')?.[0]?.data || [];
  // const reviews = items.find((block) => block.type === 'reviews')?.data || [];
  const itemListElement = courses.map((course, index) => ({
    '@type': 'Course',
    '@id': course.permalink,
    position: index + 1,
    name: course.name,
    url: course.permalink,
    about: course.description || course.name,
    description: course.description || course.name,
    thumbnailUrl: course.coverPhoto || course.cover_photo || course.thumbnail,
    courseCode: course.uid,
    accessMode: ['auditory', 'visual'],
    isAccessibleForFree:
      course.forPlus || course.forSubscription ? 'False' : 'True',
    inLanguage: course.languageDisplay || course.language_display,
    provider: {
      '@type': 'Organization',
      name: 'Unacademy',
      sameAs: 'https://unacademy.com/'
    }
  }));

  const graph = [organization, breadcrumbSchema(breads)];
  const faqSchemaEntry = faqSchema(faqs);
  if (faqSchemaEntry) graph.push(faqSchemaEntry);
  const itemListSchemaEntry = itemlistSchema(description, itemListElement);
  if (itemListSchemaEntry) graph.push(itemListSchemaEntry);

  const schema = {
    '@context': 'https://schema.org/',
    '@graph': graph
  };

  return schema;
};

export default goalSchema;
